
export const ValidFile = () => (<angular.IDirective>{

    require: 'ngModel',

    link: (scope: angular.IScope, el: any, attrs: any, ngModel: angular.INgModelController) => {
        ngModel.$render = () => {
            ngModel.$setViewValue(el.val());
        };
        el.bind('change', () => {
            scope.$apply(() => {
                ngModel.$render();
            });
        });
    }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/valid-file/valid-file.directive.ts